import { Navigate, useLocation } from 'react-router-dom';

import { ROUTES } from '@/config/routes';
import { useIsMigrated } from '@/hooks/use-migration';

const ALLOWED: readonly string[] = [
  ROUTES.MIGRATION,
  ROUTES.LIQUIDITY_PROVIDING,
  ROUTES.REFERRALS,
  ROUTES.POINTS,
  ROUTES.CUSTOM_NETWORK_WITHDRAW,
  ROUTES.SUPPORT,
  ROUTES.TERMS,
  ROUTES.PROP_TERMS,
  ROUTES.PRIVACY,
  ROUTES.OAUTH_REDIRECT,
];

export const useIsRouteAllowedAfterMigration = () => {
  const { pathname } = useLocation();
  const isMigrated = useIsMigrated();
  return !isMigrated || ALLOWED.some((route) => pathname.startsWith(route));
};

export default function MigratedGuard({
  children,
}: {
  children: React.ReactNode;
}) {
  const isAllowed = useIsRouteAllowedAfterMigration();

  if (!isAllowed) return <Navigate to={ROUTES.MIGRATION} replace />;

  return <>{children}</>;
}
